import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { breadcrumbNodesUpdated } from "../../redux/reducer";
import {
  BASE_BREADCRUMB_NODE,
  BULK_REFRESH,
  CATALOGUE_NODE,
} from "../../constants";
import Accordion from "../Accordion/Accordion";
import SourceRefresh from "../SourceRefresh/SourceRefresh";
import SpectralRefresh from "../SpectralRefresh/SpectralRefresh";
import "./BulkRefresh.scss";
import {
  useGetHistoryUpdatesQuery,
  useLazyGetHistoryUpdatesQuery,
} from "../../redux/pointingSourcesService";
import useModal from "../Modal/useModal";
import Modal from "../Modal/Modal";
import SourceStitching from "../SourceStitching/SourceStitching";
import Authorization from "../Authorization/Authorization";
import { useParams } from "react-router-dom";

function BulkRefresh() {
  const dispatch = useDispatch();
  const {catalogueMetadataId}=useParams();
  const [trigger, result] = useLazyGetHistoryUpdatesQuery();


  const [tabs, setTabs] = useState({
    tabNames:["Source refresh", "Source stitch","Spectral refresh"],
    activeTab:"Source refresh"
});


  const [historyDisplayData, setHistoryDisplayData] = useState({
    "Source refresh": [],
    "Source stitch": [],
    "Spectral refresh": []
  });
  const {
    isShowing,
    openModal: openHistoryModal,
    closeModal: closeHistoryModal,
  } = useModal();
  useEffect(() => {
    dispatch(
      breadcrumbNodesUpdated({
        breadcrumbNodes: [
          ...BASE_BREADCRUMB_NODE,
          ...CATALOGUE_NODE,
          ...BULK_REFRESH,
        ],
      })
    );
  }, []);

  const onClose = () => {
    closeHistoryModal();
  };

  const groupBy = (data, key) => {
    return data.filter(item =>
      item.change_type === key
    )
  }

  useEffect(() => {
    if (result?.currentData) {

      setHistoryDisplayData({
          "Source refresh":groupBy(result?.currentData, "Source refresh"),
          "Source stitch":groupBy(result?.currentData, "Source stitch"),
          "Spectral refresh":groupBy(result?.currentData, "Spectral refresh"),
        }
      )
    }
  }, [result?.currentData])
  const displayFormat = (data) => {
    return data?.map((logItem) => {
      return (
        <div className="log">
          <div className="log_info">
            <div className="triggered_info">
              <span className="log_info_title">Triggered By: </span>
              <span className="log_info_value">{logItem.user}</span>
            </div>
            <div className="change_type">
              <span className="log_info_title">Type: </span>
              <span className="log_info_value">{logItem.change_type}</span>
            </div>
            <div className="status">
              <span className="log_info_title">Status: </span>
              <span className="log_info_value">{logItem.status}</span>
            </div>
            <div className="timestamp">
              <span className="log_info_title">Timestamp: </span>
              <span className="log_info_value">{logItem.timestamp}</span>
            </div>
          </div>
          <pre>
            {JSON.stringify(logItem.log, undefined, 2).replace(/\\n/g, "\n")}
          </pre>
        </div>
      );
    });
  };
  return (
   <Authorization>
       <>
      <Modal
        isShowing={isShowing}
        close={onClose}
        title="History"
        displayModal={true}
        customClass="history-modal"
      >
        {
          <div className="tabs">
            {/* Tab nav */}
            <ul className="nav">
              {tabs.tabNames.map((tab) => {
                return (
                  <li
                    className={`tab${tabs.activeTab===tab ? " active" : ""}`}
                    onClick={()=>setTabs((prev)=>{
                      return {
                        ...prev,
                        activeTab:tab
                      }
                    })}
                  >
                    {tab}
                  </li>
                );
              })}
            </ul>
            {tabs && <div className="outlet">{displayFormat(historyDisplayData[tabs.activeTab])}</div>}
          </div>
        }
      </Modal>
      <div className="bulk-refresh-container">
        <button
          className="bg-green-button history-btn"
          onClick={() => {
            openHistoryModal();
            const timestampRef = Date.now();
            trigger({ sessionId: timestampRef,catalogueId:catalogueMetadataId });
          }}
        >
          History
        </button>
        <div className="acc_container">
          <Accordion useArrows={true}>
            <h4>Source Refresh</h4>
            <SourceRefresh />
          </Accordion>
          <Accordion useArrows={true}>
            <h4>Source Stitching</h4>
            <SourceStitching />
          </Accordion>
          <Accordion useArrows={true}>
            <h4>Spectral Refresh</h4>
              <SpectralRefresh />
          </Accordion>
        </div>
      </div>
    </>
   </Authorization>
  );
}

export default BulkRefresh;
